<template>
    <div class="left_menu flex flexcolumn FlexEvenly">
        <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList" :key="index"
            :class="[selectMenu == item.value ? 'active_menu_one' : '']" @click="changeMenu(item)">
            <el-image class="menu_icon" :src="imgPath(item.icon)" v-if="selectMenu != item.value"></el-image>
            <el-image class="menu_icon" :src="imgPath(item.activeIcon)" v-else></el-image>
            <div>{{ item.label }}</div>
        </div>
        <learningGuide ref="learningGuide"></learningGuide>
    </div>
</template>

<script>
import learningGuide from "@/components/popup/learningGuide.vue";
import { mapState } from "vuex";
export default {
    name: 'GjkcH5LeftMenu',
    props: {
        leftMenu: {}
    },
    components:{
        learningGuide
    },
    computed: {
        ...mapState({
            isFirstLearning: (state) => state.user.isFirstLearning
        }),
    },

    data() {
        return {
            menuList: [
                // { label: '简介', icon: 'introduce_icon.png', activeIcon: 'introduce_active_icon.png', value: 1 },
                { label: '待办', icon: 'backlog_icon.png', activeIcon: 'backlog_active_icon.png', value: 7 },
                { label: '学堂', icon: 'school_icon.png', activeIcon: 'school_active_icon.png', value: 2 },
                // { label: '测验', icon: 'test_icon.png', activeIcon: 'test_active_icon.png', value: 3 },
                { label: '讨论组', icon: 'discussion_icon.png', activeIcon: 'discussion_active_icon.png', value: 4 },
                // { label: '考试', icon: 'exam_icon.png', activeIcon: 'exam_active_icon.png', value: 5 },
                { label: '综合评定', icon: 'evaluation_icon.png', activeIcon: 'evaluation_active_icon.png', value: 6 },
            ],
            selectMenu: 7,
        };
    },
    watch: {
        leftMenu() {
            this.selectMenu = this.leftMenu;
            if (this.selectMenu == 2) {
                // 判断是否弹过学习指引（true则不再弹起）
                if (!this.isFirstLearning) {
                    setTimeout(() => {
                        if (this.$refs.learningGuide) {
                            this.$refs.learningGuide.learningGuideShow = true;
                            this.$store.commit("user/setIsFirstLearning", true);  // 设置缓存，不重复弹起学习指引弹窗
                        }
                    }, 1500);
                }
            }
        }
    },
    mounted() {
        this.selectMenu = this.leftMenu;
    },

    methods: {
        changeMenu(info) {
            this.selectMenu = info.value;
            this.$emit('getMenu', info.value)
        }
    },
};
</script>
<style lang="scss" scoped>
.left_menu {
    width: 68px;
    // height: 428px;
    height: 368px;
    background: #FFFFFF;
    border-radius: 10px;

    .menu_one {
        width: 68px;
        height: 58px;
        font-size: 14px;
        color: #666666;

        .menu_icon {
            width: 30px;
            height: 30px;
        }
    }

    .active_menu_one {
        background: rgba(230, 254, 235, .5);
        color: #13D6AA;
    }
}
</style>